import './Section01.css';
import React, { useState } from "react";
import { Accordion, Modal } from "react-bootstrap";
import Video1 from '../../Home/Section01/video/doceDeLeite.mp4';
import Video2 from '../../Home/Section01/video/ambrosia.mp4';
import Video3 from '../../Home/Section01/video/gelato.mp4';

import Imagem1 from '../../Home/Section01/img/bolo1.jpeg';
import Imagem2 from '../../Home/Section01/img/bolo2.jpeg';
import Imagem3 from '../../Home/Section01/img/bolo3.jpeg';
import Imagem4 from '../../Home/Section01/img/sophia.jpeg';
import Imagem5 from '../../Home/Section01/img/muffin.jpeg';
import Imagem6 from '../../Home/Section01/img/boloChurros.jpeg';


const dicas = [
  { 
    titulo: "Doce de Leite Artesanal no Fogão a Lenha", 
    descricao: "Veja como nasce o Doce de Leite Artesanal no fogão a lenha da DS Doces. 'Clique aqui' e assista ao vídeo do produto.", 
    tipo: "video", 
    src: Video1,
    instrucao: "Dica: Mexa sempre em fogo baixo."
  },
  {
    titulo: "Ambrosia Cremosa no Fogão a Lenha",
    descricao: "Ambrosia feita no fogão a lenha, com um leve gostinho de pudim! 'Clique aqui' e assista ao vídeo do produto.",
    tipo: "video",
    src: Video2,
    instrucao: "Dica: Mexa sempre em fogo baixo."
  },
  {
    titulo: "Bolo de Churros com Doce de Leite Artesanal",
    descricao: "Uma parceira especial preparou esse bolo de churros irresistível usando o doce de leite artesanal da DS Doces. 'Clique aqui' e veja como essa combinação transforma qualquer receita em uma verdadeira obra de sabor!",
    tipo: "imagem",
    src: [Imagem2, Imagem3, Imagem1], // Array de imagens para o carrossel improvisado aqui desse item kkk
    instrucao: "Dica: Perfeito para acompanhar sorvetes e brigadeiros."
  },
  {
    titulo: "Lembrancinha de Aniversário com Doce de Leite Artesanal",
    descricao: "Uma parceira especial criou essa opção criativa e deliciosa: potes de vidro recheados com o doce de leite artesanal da DS Doces, usados como lembrancinhas de aniversário. 'Clique aqui' e veja como foi transformar o produto em um presente bem elaborado e inesquecível!",
    tipo: "imagem",
    src: Imagem4,
    instrucao: "Dica: Personalize os potes com fitas e etiquetas para um toque especial."
  },
  {
    titulo: "Gelato Artesanal",
    descricao: "Esse gelato é um sorvete artesanal feito com doce de leite e creme de leite fresco. Uma combinação perfeita! Veja o produto 'clicando aqui.' ",
    tipo: "video",
    src: Video3,
    instrucao: "Dica: Perfeito para acompanhar bolos e sobremesas."
  },
  {
    titulo: "Muffin Recheado com Doce de Leite Artesanal",
    descricao: "Esse muffin fofinho, feito por uma nutricionista parceira, ganhou um recheio irresistível de doce de leite artesanal da DS Doces. 'Clique aqui' para ver e descubra como essa delícia pode transformar o seu café da tarde!",
    tipo: "imagem",
    src: Imagem5, // Array de imagens para o carrossel improvisado aqui desse item  
    instrucao: "Dica: Experimente aquecer por alguns segundos antes de servir — o recheio fica ainda mais cremoso."
  },
  {
    titulo: "Bolo de Churros com Cobertura de Doce de Leite Artesanal",
    descricao: "Uma parceira preparou esse bolo de churros incrível e usou o doce de leite artesanal da DS Doces como cobertura. 'Clique aqui' e veja como essa combinação transforma qualquer receita em uma explosão de sabor!",
    tipo: "imagem",
    src: Imagem6,
    instrucao: "Dica: Para deixar ainda mais especial, finalize com uma pitada de canela sobre o doce de leite."
  }
];

const Section01 = () => {
  const [show, setShow] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);

  const handleShow = (media) => {
    setSelectedMedia(media);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  return (
    <div className='section1_1'>
      <h1 className='title'>Curiosidades, Dicas e Novidades da DS Doces</h1>
      
      <Accordion>
        {dicas.map((dica, index) => (
          <Accordion.Item eventKey={index.toString()} key={index}>
            <Accordion.Header>{dica.titulo}</Accordion.Header>
            <Accordion.Body>
              <p className="callback-text" onClick={() => handleShow(dica)}>
                {dica.descricao}
              </p>
              <p className="instrucao">{dica.instrucao}</p>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>

      {/* Modal para exibir conteúdo ampliado */}
        <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Body>
            {selectedMedia && (
            selectedMedia.tipo === "video" ? (
                <video src={selectedMedia.src} controls autoPlay className="modal-video"/>
            ) : (
                Array.isArray(selectedMedia.src) ? (
                selectedMedia.src.map((img, i) => (
                    <img key={i} src={img} alt={`Imagem ${i+1}`} className="modal-img"/>
                ))
                ) : (
                <img src={selectedMedia.src} alt="Imagem ampliada" className="modal-img"/>
                )
            )
            )}
        </Modal.Body>
        </Modal>

    </div>
  );
};

export default Section01;
